import React from 'react'

import * as R from 'ramda'

import { Button, Div, Span } from '@driftt/tide-core'
import { Select } from '@driftt/tide-selects'

const sizeOptions = [{label: 20, value: 20}, {label: 50, value: 50}, {label: 100, value: 100}]

const Paginator = ({ totalPages, index, goForward, goBackward, changeSize, size }) => {
  const canGoBack = !index
  const canGoForwards = (index + 1) >= totalPages

  return (
    <Div className="reports-table-pagination">
      <Div className="reports-table-pagination-size">
        <Select options={sizeOptions} menuPlacement="top" isClearable={false} value={R.find(R.propEq('value', size), sizeOptions)} onChange={changeSize} className="reports-table-pagination-size-select" />
      </Div>
      <Div className="reports-table-pagination-controls">
        <Div className="reports-table-pagination-previous">
          {totalPages > 1 && <Button type="subtle" onClick={goBackward} icon="arrow-1-left" disabled={canGoBack} />}
        </Div>
        <Div className="reports-table-pagination-location">
          <Span>page {index + 1} of {totalPages || 1}</Span>
        </Div>
        <Div className="reports-table-pagination-next">
          {totalPages > 1 && <Button  type="subtle" disabled={canGoForwards} onClick={goForward} icon="arrow-1-right" iconAlignment="right" />}
        </Div>
      </Div>
      <Div className="reports-table-pagination-blank"></Div>
    </Div>
  )
}

export default Paginator
